<div
  class="whatsapp-widget"
  [class.expanded]="isExpanded"
  [class.closing]="isClosing"
>
  <!-- Collapsed state - floating button -->
  <div
    class="whatsapp-button"
    *ngIf="!isExpanded"
    (click)="toggleWidget($event)"
  >
    <div class="help-text">Need Help?</div>
    <div class="button-icon">
      <mat-icon>support_agent</mat-icon>
    </div>
  </div>

  <!-- Expanded state - chat widget -->
  <div class="whatsapp-chat-widget" *ngIf="isExpanded || isAnimating">
    <!-- Header -->
    <div class="chat-header">
      <div class="profile-section">
        <div class="profile-avatar">
          <img
            [src]="
              'https://ui-avatars.com/api/?name=' +
              agentName +
              '&background=344734&color=fff&size=150'
            "
            [alt]="agentName"
          />
          <div class="online-indicator"></div>
        </div>
        <div class="profile-info">
          <div class="profile-name">{{ agentName }}</div>
          <div class="profile-status">{{ agentStatus }}</div>
        </div>
      </div>
      <button class="close-button" (click)="toggleWidget($event)">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <!-- Chat preview -->
    <div class="chat-preview">
      <div class="message-bubble">
        <div class="message-sender">{{ agentName }}</div>
        <div class="message-text" [innerHTML]="formattedWelcomeMessage"></div>
        <div class="message-time">{{ currentTime }}</div>
      </div>
    </div>

    <!-- Start chat button -->
    <div class="chat-actions">
      <a
        [href]="whatsappUrl"
        target="_blank"
        class="start-chat-button"
        (click)="toggleWidget($event)"
      >
        <mat-icon>chat</mat-icon>
        Start Chat
      </a>
    </div>
  </div>
</div>
